import Utils from "../js/utils/base.Utils";

export default class BaseModal {

  set localStrings (strings) {
    this._localStrings = strings;
    this.onLanguageChanged();
  }
  get localStrings () { return this._localStrings[Utils.Language.getUserLanguage()]; }

  get wrapper () { return document.querySelector('.popup-wrapper'); }

  constructor (modalParams, params) {
    this.params = params;
    this.wrapper.innerHTML = modalParams.html;
    this.result = null;

    $(this.wrapper).on('click', (e) => {
      if($(e.target).hasClass('popup-wrapper'))
        this.close();
    });
    $(this.wrapper).find(' [data-action=close]').on('click', () => {
      this.close();
    });
  }

  onLanguageChanged() {
    kendo.bind($(this.wrapper), this.localStrings);
  }

  togglePopup(open) {
    let anim = open ? 'animate__bounceIn' : 'animate__bounceOut';
    $(this.wrapper).find(' > div').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend transitionEnd animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', (e) => {
      $(this.wrapper).find(' > div').off('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend transitionEnd animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd');
      $(this.wrapper).find('  > div').removeClass('animate__animated ' + anim);
      if(!open)
        $('body').removeClass('popup');
    });
    if(open)
      $('body').addClass('popup');
    $(this.wrapper).find(' > div').addClass('animate__animated ' + anim);
  }

  open() {
    this.togglePopup(true);
  }
  close() {
    if(this.destroy) {
      this.destroy();
    }
    $(this.wrapper).off('click');
    $(this.wrapper).find(' [data-action=close]').off('click');
    this.togglePopup(false);
    const event = new CustomEvent('modal-close', { detail: this.result });
    this.wrapper.dispatchEvent(event);
  }
}
